import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PlayerProfileForm from "@/components/PlayerProfileForm";

export default function Profile() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) return;
        if (!user) { navigate("/login"); return; }
        if (user.role !== "player_parent") { navigate("/"); return; }
    }, [user, loading, navigate]);

    if (loading || !user) return <div className="text-center text-[#a0a0a0] py-20">Loading…</div>;

    return (
        <div className="max-w-2xl mx-auto px-6 py-10" data-testid="profile-page">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Your profile</div>
            <h1 className="font-display text-5xl tracking-wide">Player profile</h1>
            <p className="text-sm text-[#a0a0a0] mt-2">Update your details — teams find you by these fields.</p>

            <div className="mt-8">
                <PlayerProfileForm />
            </div>
        </div>
    );
}
